export default "__VITE_ASSET__8bf2f50d__"